
import XHeader from 'vux/src/components/x-header/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

export default {
name: "fee-paid",
components: {
XHeader,Selector
},
data(){
return{
scores:[
{key: '10', value: '10'},
{key: '9', value: '9'},
{key: '8', value: '8'},
{key: '7', value: '7'},
{key: '6', value: '6'},
{key: '5', value: '5'},
{key: '4', value: '4'},
{key: '3', value: '3'},
{key: '2', value: '2'},
{key: '1', value: '1'},
],
course:'大学数学',
teacher:'老王',
desc:[
{id:'1',content:"奥斯卡金凤凰卡萨几点发货",score:'10'},
{id:'2',content:"奥斯就是打电话分手的尽快发货山东矿机发的发送到发的胜多负少的发货",score:'10'},
{id:'3',content:"奥斯卡金时段发是可敬的复活卡的设计费哈迪斯就点发货",score:'10'},
{id:'4',content:"奥斯第三发送到发送到卡萨几点发货",score:'10'},
{id:'5',content:"奥斯卡金凤凰水电费水电费三大发送到发送到点发货",score:'10'},
{id:'6',content:"奥斯卡金凤是电饭锅电饭锅电饭锅几点发货",score:'10'},

],
}
},
methods: {
onChange(val) {
console.log(val)
},
}
}



// WEBPACK FOOTER //
// ./src/components/evaluation.vue